export const LOAD_CLIENT = 'LOAD_CLIENT';
export const SET_SOOTHE_PASS_DISCOUNT_AVAILABILITY = 'SET_SOOTHE_PASS_DISCOUNT_AVAILABILITY';

export function loadClient(user) {
  return {
    type: LOAD_CLIENT,
    payload: user,
  };
}

export function setSoothePassDiscountAvailability(available, loading = false) {
  return {
    type: SET_SOOTHE_PASS_DISCOUNT_AVAILABILITY,
    payload: {
      soothe_pass_discount_available: available,
      soothe_pass_discount_loading: loading,
    },
  };
}
